$(function() {

    if ( $(".offers__filters").length ) {
        if ( $(".offers__drop-item").length > 7 ) {
            $(".offers__filter-dropdown").addClass("offers__filter-dropdown--big");
        }
        $(".offers__filter-main").click(function() {
            var filter = $(this).closest(".offers__filter");
            if ( filter.hasClass("active") ) {
                $(".filter-bg").hide();
                filter.removeClass("active");
                // filter.find(".offers__filter-dropdown").removeClass("active");
            }else{
                // $(".offers__filter-main").removeClass("active");
                // $(".offers__filter").removeClass("active");
                // $(".offers__filter-dropdown").removeClass("active");
                $(".filter-bg").show();
                filter.addClass("active");
                // $(this).siblings(".offers__filter-dropdown").addClass("active");
            }
        });
        // $(document).on('mousedown touchstart', function (e){ // событие клика по веб-документу
        //     var div = $(".offers__filter");
        //     if ( !div.is(e.target) && div.has(e.target).length === 0 ) {
        //         div.find(".offers__filter-main").removeClass("active");
        //         div.find(".offers__filter-dropdown").removeClass("active");
        //     }
        // });
        $(".filter-bg").click(function() {
           $(this).hide();
           $(".offers__filter").removeClass("active");
        });

        var rangeSlider = $(".offers__range")[0];
        noUiSlider.create(rangeSlider, {
            start: [10, 20],
            connect: true,
            tooltips: true,
            format: {
                from: function(value) {
                    return parseInt(value);
                },
                to: function(value) {
                    return parseInt(value);
                }
            },
            margin: 1,
            step: 1,
            range: {
                'min': 0,
                'max': 30
            }
        });
        rangeSlider.noUiSlider.on('update', function (values, handle) {
            // console.log(values, handle);
            // valuesDivs[handle].innerHTML = values[handle];
            // diffDivs[0].innerHTML = values[1] - values[0];
            // diffDivs[1].innerHTML = values[2] - values[1];
            // diffDivs[2].innerHTML = values[3] - values[2];
        });

    }//offers__filters

    //обрезаем текстовый блок и добавляем ...
    $('.offer-item__text, .blog__item-text, .art-list__text').each(function () {
        if ( $(this).text().length > 140 ) {
            $(this).text( $(this).text().slice(0, 140)  + "...");
        }
    });
    $('.offer .offer-item__text').each(function () {
        if ( $(this).text().length > 110 ) {
            $(this).text( $(this).text().slice(0, 110)  + "...");
        }
    });




});